module.exports = __webpack_public_path__ + "img/memory-used.4ea409c8.png";